import axios from 'axios';
import API_URL from '../../config/ApiUrl';
import { makeAutoObservable } from 'mobx';
import RootStore from '../RootStore/RootStore';
import { ServerGridConfig } from '../../config/GridConfig';
import { Notification } from '../../config/Global';

export default class TourPackageCategoryStore {
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	searchValue = '';
	categoryList = [];
	categoryDetail = null;

	constructor() {
		makeAutoObservable(this);
		this.rootStore = new RootStore();
	}

	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				const payload = this.rootStore.getServerListPayload(
					params,
					this.searchValue
				);
				this.getList({
					...payload,
				})
					.then(({ data, totalRecords }) => {
						if (totalRecords === 0) {
							this.agGrid.api.showNoRowsOverlay();
						} else {
							this.agGrid.api.hideOverlay();
						}
						params.success({
							rowData: data,
							rowCount: totalRecords,
						});
					})
					.catch((err) => {
						params.fail(err);
					});
			},
		};
	};

	getList = async (payload) => {
		try {
			const { data } = await axios.get(
				`${API_URL.TOURPACKAGECATEGORY.LIST}?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&sortBy=${payload.sortBy}&searchValue=${encodeURIComponent(payload.searchValue)}&isActive=1`
			);
			return data.data;
		} catch {}
	};

	addCategory = async (formData) => {
		return await axios
			.post(API_URL.TOURPACKAGECATEGORY.ADD, formData)
			.then(({ data }) => {
				this.setupGrid(this.agGrid);
				if (data.httpStatusCode === 200) {
					return data;
				} else {
					Notification.error({ message: data.message });
					return Promise.reject(data);
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	deleteCategory = async ({ id, versionNo }) => {
		try {
			const encodeURL =
				'?id=' + encodeURIComponent(id) + '&versionNo=' + versionNo;
			const { data } = await axios.delete(
				API_URL.TOURPACKAGECATEGORY.DELETE + encodeURL
			);
			this.setupGrid(this.agGrid);
			return data.message;
		} catch (err) {
			Promise.reject(err);
		}
	};

	ReadCategory = async (id) => {
		try {
			const { data } = await axios.get(
				API_URL.TOURPACKAGECATEGORY.SINGLE + '?id=' + encodeURIComponent(id)
			);
			this.categoryDetail = data.data;
			return data.data;
		} catch {}
	};

	editCategory = async (formData) => {
		return await axios
			.put(API_URL.TOURPACKAGECATEGORY.UPDATE, formData)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				if (data.httpStatusCode === 200) {
					return data;
				} else {
					Notification.error({ message: data.message });
					return Promise.reject(data);
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};
}
